// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .paylixecommerce-table table tbody tr td {
  border-top: 1px solid var(--black1) !important;
}
.dark .paylixecommerce-table table thead tr th {
  background: var(--black1);
}
.dark .paylixecommerce-table-pagination {
  border-top: 1px solid var(--black1) !important;
  background: var(--black1);
}
.dark .page-size-container .select-container {
  background-color: var(--white);
}

.paylixecommerce-table {
  width: 100%;
  overflow-x: auto;
}
.paylixecommerce-table-clear {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;
}
.paylixecommerce-table-clear-icon {
  margin-bottom: 1.5rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  background: var(--purple0);
  display: flex;
  align-items: center;
  justify-content: center;
}
.paylixecommerce-table-clear-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.paylixecommerce-table-clear-title {
  margin-bottom: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: var(--black9);
}
.paylixecommerce-table-clear-text {
  margin-bottom: 1.5rem;
  color: var(--black5);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.paylixecommerce-table-container {
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}
.paylixecommerce-table-container.cursor-pointer table tr td {
  cursor: pointer;
}
.paylixecommerce-table-container .paylixecommerce-table {
  background: var(--white);
  border-radius: 0.5rem 0.5rem 0 0;
}
.paylixecommerce-table-container.skip-pagination {
  border-radius: 0.5rem;
  box-shadow: none;
}
.paylixecommerce-table-container.skip-pagination .paylixecommerce-table {
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}
.paylixecommerce-table-container.skip-pagination .paylixecommerce-table table {
  border-radius: 0.5rem;
}
.paylixecommerce-table tbody tr:nth-last-child(-n+3) .paylixecommerce-table-actions-modal {
  flex-direction: row;
  top: -1rem;
  right: 1.5rem;
  width: auto;
  transform: none;
}
.paylixecommerce-table table {
  border-radius: 0.5rem;
}
.paylixecommerce-table-container {
  width: 100%;
  max-width: 100%;
}
@media (max-width: 768px) {
  .paylixecommerce-table {
    overflow: scroll;
  }
}
.paylixecommerce-table-nothing {
  padding: 2rem 0;
  color: var(--black9);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.paylixecommerce-table-actions {
  display: flex;
  justify-content: flex-end;
  position: relative;
  padding: 0.25rem 0.5rem;
}
.paylixecommerce-table-actions img:hover + div {
  display: flex;
}
.paylixecommerce-table-actions > div {
  position: absolute;
  top: 1rem;
  display: none;
}
.paylixecommerce-table-actions > img {
  cursor: pointer;
}
.paylixecommerce-table-actions:hover .paylixecommerce-table-actions-modal {
  display: flex;
}
.paylixecommerce-table-actions-modal {
  z-index: 9;
  position: absolute;
  top: calc(100% - 0.5rem);
  right: -5rem;
  display: none;
  flex-direction: column;
  width: 8rem;
  background: var(--white);
  transform: translateX(-50%);
  box-shadow: 0 4px 24px -4px rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem;
  font-size: 14px;
  margin-top: 0.5rem;
  overflow: hidden;
  background: var(--white);
  border: none;
}
@media (max-width: 768px) {
  .paylixecommerce-table-actions-modal {
    flex-direction: row;
    width: auto;
    top: calc(50% - 25px) !important;
    right: 2rem;
    transform: none;
  }
}
.paylixecommerce-table-actions-modal > div, .paylixecommerce-table-actions-modal > a, .paylixecommerce-table-actions-modal > span {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0.75rem;
  height: 36px;
  line-height: 36px;
  color: var(--black5) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
}
.paylixecommerce-table-actions-modal > div span, .paylixecommerce-table-actions-modal > a span, .paylixecommerce-table-actions-modal > span span {
  margin-left: 0.5rem;
}
@media (max-width: 768px) {
  .paylixecommerce-table-actions-modal > div, .paylixecommerce-table-actions-modal > a, .paylixecommerce-table-actions-modal > span {
    padding: 1rem;
  }
  .paylixecommerce-table-actions-modal > div i, .paylixecommerce-table-actions-modal > a i, .paylixecommerce-table-actions-modal > span i {
    margin-right: 0 !important;
    font-size: 1rem;
  }
  .paylixecommerce-table-actions-modal > div > span, .paylixecommerce-table-actions-modal > a > span, .paylixecommerce-table-actions-modal > span > span {
    display: none;
  }
}
.paylixecommerce-table-actions-modal > div.delete-icon, .paylixecommerce-table-actions-modal > a.delete-icon, .paylixecommerce-table-actions-modal > span.delete-icon {
  color: var(--red6) !important;
}
.paylixecommerce-table-actions-modal > div.delete-icon:hover, .paylixecommerce-table-actions-modal > a.delete-icon:hover, .paylixecommerce-table-actions-modal > span.delete-icon:hover {
  color: var(--red6) !important;
  background: var(--red0);
}
.paylixecommerce-table-actions-modal > div:hover, .paylixecommerce-table-actions-modal > a:hover, .paylixecommerce-table-actions-modal > span:hover {
  color: var(--black9) !important;
  background: var(--black1);
}
.paylixecommerce-table-actions-modal > div img, .paylixecommerce-table-actions-modal > a img, .paylixecommerce-table-actions-modal > span img {
  margin-right: 0.75rem;
}
.paylixecommerce-table-actions-modal > div i, .paylixecommerce-table-actions-modal > a i, .paylixecommerce-table-actions-modal > span i {
  color: var(--black9);
  margin-right: 0.75rem;
}
.paylixecommerce-table-pagination {
  display: flex;
  justify-content: space-between;
  color: var(--black6);
  padding: 1rem 1.25rem;
  list-style: none;
  border-top: 1px solid var(--black0) !important;
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: var(--white);
}
@media (max-width: 768px) {
  .paylixecommerce-table-pagination {
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }
  .paylixecommerce-table-pagination .page-size-container {
    margin-bottom: 0;
  }
  .paylixecommerce-table-pagination > div {
    width: 100%;
    justify-content: center;
    margin-bottom: 1rem;
  }
}
.paylixecommerce-table-pagination button {
  width: 2rem;
  padding: 0;
}
.paylixecommerce-table-pagination button.active {
  border-color: var(--purple6);
  border-width: 2px;
}
.paylixecommerce-table-pagination button.active:hover {
  background-color: var(--white);
}
.paylixecommerce-table-pagination button.more svg {
  margin-top: 0.25rem;
}
.paylixecommerce-table-pagination .page-size-container .select-container {
  max-height: 2rem;
  height: 2rem;
}
.paylixecommerce-table-pagination .page-size-container > span {
  font-size: 13px;
  font-weight: 500;
  color: var(--black4);
}
.paylixecommerce-table-pagination > div {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
@media (max-width: 768px) {
  .paylixecommerce-table-pagination > div {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
.paylixecommerce-table-pagination .paylixecommerce-select {
  width: 7rem;
  height: 2rem;
  margin-left: 1rem;
  font-size: 0.8rem;
}
.paylixecommerce-table-pagination .paylixecommerce-input {
  width: 5rem;
  height: 2rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  background: var(--white);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.paylixecommerce-table-pagination .paylixecommerce-input::-webkit-outer-spin-button, .paylixecommerce-table-pagination .paylixecommerce-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.paylixecommerce-table-pagination .paylixecommerce-input[type=number] {
  -moz-appearance: textfield;
}
.paylixecommerce-table table {
  background: var(--white);
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  margin-bottom: 0;
  table-layout: auto;
  width: 100%;
}
.paylixecommerce-table table.last-right thead tr th:last-child {
  text-align: right;
}
.paylixecommerce-table table.last-right tbody tr td:last-child {
  text-align: right;
}
.paylixecommerce-table table.last-center thead tr th:last-child {
  text-align: center;
}
.paylixecommerce-table table.last-center tbody tr td:last-child {
  text-align: center;
}
.paylixecommerce-table table thead th {
  background: var(--white);
  color: var(--black4);
  padding: 0.875rem 0.75rem 0.875rem 1.25rem;
  border-bottom: none !important;
  border-top: none !important;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}
.paylixecommerce-table table thead th:first-child {
  padding-left: 1.25rem !important;
  border-radius: 0.5rem 0 0 0;
}
.paylixecommerce-table table thead th:last-child {
  padding-right: 1rem;
  border-radius: 0 0.5rem 0 0;
}
.paylixecommerce-table table thead th:focus {
  outline: none;
}
.paylixecommerce-table table tbody tr:last-child td:first-child {
  border-radius: 0 0 0 0.5rem;
}
.paylixecommerce-table table tbody tr:last-child td:last-child {
  border-radius: 0 0 0.5rem 0;
}
.paylixecommerce-table table tbody tr:hover {
  background: var(--black0);
}
.paylixecommerce-table table tbody tr:hover td {
  color: var(--black9);
}
.paylixecommerce-table table tbody tr td {
  vertical-align: middle;
  padding: 13px 0 !important;
  padding-left: 1.25rem !important;
  border: none;
  border-top: 1px solid var(--black0) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
}
.paylixecommerce-table table tbody tr td:first-child {
  padding-left: 1.25rem !important;
}
.paylixecommerce-table table tbody tr td:last-child {
  padding-right: 1.25rem !important;
}
.paylixecommerce-table table tbody tr td a {
  color: var(--black9);
}
.paylixecommerce-table table tbody tr td a:hover {
  color: #6461FC;
  text-decoration: none;
}
.paylixecommerce-table table tbody tr td a b {
  font-weight: 600;
}
.paylixecommerce-table::-webkit-scrollbar {
  width: 3px !important;
  height: 3px !important;
  background-color: transparent !important;
}
.paylixecommerce-table::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.paylixecommerce-table::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

span.color-purple {
  color: var(--purple6);
  font-size: 12px;
  line-height: 12px;
}

.product-screen div.mde-preview div.mde-preview-content {
  color: var(--black9);
}
.product-screen div.mde-preview div.mde-preview-content h1 + p:first-child, .product-screen div.mde-preview div.mde-preview-content h2 + p:first-child, .product-screen div.mde-preview div.mde-preview-content h3 + p:first-child, .product-screen div.mde-preview div.mde-preview-content h4 + p:first-child, .product-screen div.mde-preview div.mde-preview-content h5 + p:first-child, .product-screen div.mde-preview div.mde-preview-content h6 + p:first-child,
.product-screen div.mde-preview div.mde-preview-content h1 + ul:first-child, .product-screen div.mde-preview div.mde-preview-content h2 + ul:first-child, .product-screen div.mde-preview div.mde-preview-content h3 + ul:first-child, .product-screen div.mde-preview div.mde-preview-content h4 + ul:first-child, .product-screen div.mde-preview div.mde-preview-content h5 + ul:first-child, .product-screen div.mde-preview div.mde-preview-content h6 + ul:first-child {
  margin-top: 0.5rem;
}
.product-screen div.mde-preview div.mde-preview-content h1, .product-screen div.mde-preview div.mde-preview-content h2, .product-screen div.mde-preview div.mde-preview-content h3, .product-screen div.mde-preview div.mde-preview-content h4, .product-screen div.mde-preview div.mde-preview-content h5, .product-screen div.mde-preview div.mde-preview-content h6 {
  margin-bottom: 0;
  border-bottom: 0;
  border-bottom: none;
}
.product-screen div.mde-preview div.mde-preview-content h2, .product-screen div.mde-preview div.mde-preview-content h3, .product-screen div.mde-preview div.mde-preview-content h4, .product-screen div.mde-preview div.mde-preview-content h5, .product-screen div.mde-preview div.mde-preview-content h6 {
  margin-top: 1rem;
}
.product-screen div.mde-preview div.mde-preview-content a {
  color: var(--purple6);
}
.product-screen div.mde-preview div.mde-preview-content p {
  margin-bottom: 0.25rem;
}
.product-screen div.mde-preview div.mde-preview-content p:last-of-type {
  margin-bottom: 0;
}
.product-screen div.mde-preview div.mde-preview-content p, .product-screen div.mde-preview div.mde-preview-content ol, .product-screen div.mde-preview div.mde-preview-content ul {
  font-size: 0.85rem;
  color: var(--black7);
}
.product-screen div.mde-preview div.mde-preview-content blockquote {
  padding: 0.75rem;
  border-radius: 0.25rem;
  margin-top: 1rem;
  margin-left: 0;
  border-left: 0.25em solid var(--black1);
}
.product-screen div.mde-preview div.mde-preview-content ol, .product-screen div.mde-preview div.mde-preview-content ul {
  line-height: 1.25rem;
  padding-left: 0.75rem;
  list-style: disc;
}
.product-screen div.mde-preview div.mde-preview-content h3 {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.product-screen div.mde-preview div.mde-preview-content code {
  color: #d63384;
  padding: 0.25rem 0.5rem;
  margin: 0 0.125rem;
  font-size: 90%;
  background-color: black;
  border-radius: 0.5rem;
}
.product-screen-filters-block {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}
@media (max-width: 500px) {
  .product-screen-filters-block > div {
    width: 100%;
  }
}
.product-screen .paylixecommerce-table tbody tr:nth-last-child(-n+3) .paylixecommerce-table-actions-modal {
  right: 2rem;
}
@media (max-width: 768px) {
  .product-screen .screen-filters .product-menu {
    width: 100%;
  }
}
.product-screen .edit-modal::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background-color: transparent;
}
.product-screen .edit-modal::-webkit-scrollbar-track {
  background-color: transparent;
}
.product-screen .edit-modal::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}

.product-menu {
  position: relative;
  cursor: pointer;
}
@media (max-width: 768px) {
  .product-menu {
    width: 50%;
    align-self: flex-end;
  }
  .product-menu button {
    width: 100%;
  }
}
.product-menu-dropdown {
  position: absolute;
  min-width: 260px;
  width: 260px;
  background: var(--white);
  border-radius: 0.5rem;
  box-shadow: 0 4px 24px -4px rgba(18, 20, 23, 0.08);
  top: calc(100% + 0.5rem);
  display: none;
  right: 0;
  z-index: 9;
}
@media (max-width: 768px) {
  .product-menu-dropdown {
    border-radius: 0.5rem;
    min-width: auto;
    width: 100%;
    max-width: 100%;
  }
}
.product-menu-dropdown.open {
  display: flex;
  flex-direction: column;
}
.product-menu-dropdown-body {
  padding: 0.5rem;
}
.product-menu-dropdown-body > a, .product-menu-dropdown-body > div {
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black5);
}
.product-menu-dropdown-body > a span, .product-menu-dropdown-body > div span {
  margin-left: 1rem;
}
.product-menu-dropdown-body > a:hover, .product-menu-dropdown-body > div:hover {
  background: var(--black1);
  border-radius: 0.25rem;
  color: var(--black9) !important;
}
.product-menu-dropdown-body > a:hover svg *, .product-menu-dropdown-body > div:hover svg * {
  stroke: var(--black9);
}
.product-menu-dropdown-body > a.active, .product-menu-dropdown-body > div.active {
  background: var(--black1);
  border-radius: 0.25rem;
  color: var(--black9) !important;
}

.product-table-type {
  display: flex;
}
.product-table-type-icon {
  background: var(--black0);
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  object-fit: cover;
  margin-right: 0.75rem;
  background: var(--black0);
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-table-type-icon svg * {
  stroke: var(--black3);
}
.product-table-type-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
  border-radius: 0.5rem;
}
.product-table-type-date {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black4);
  margin-top: 0.25rem;
}
.product-table-type-title {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./client/components/table2/index.scss","webpack://./client/entrypoints/dashboard/screens/products/product/index.scss"],"names":[],"mappings":"AACE;EACE,8CAAA;ACAJ;ADEE;EACE,yBAAA;ACAJ;ADGE;EACE,8CAAA;EACA,yBAAA;ACDJ;ADKI;EACE,8BAAA;ACHN;;ADQA;EACE,WAAA;EACA,gBAAA;ACLF;ADOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;ACLJ;ADOI;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACLN;ADOM;EACE,aAAA;EACA,cAAA;ACLR;ADQI;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;ACNN;ADQI;EACE,qBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ACNN;ADUE;EACE,qBAAA;EACA,iFAAA;ACRJ;ADUI;EACE,eAAA;ACRN;ADWI;EACE,wBAAA;EACA,gCAAA;ACTN;ADYI;EACE,qBAAA;EACA,gBAAA;ACVN;ADYM;EACE,qBAAA;EACA,iFAAA;ACVR;ADYQ;EACE,qBAAA;ACVV;ADoBQ;EACE,mBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AClBV;ADwBE;EACE,qBAAA;ACtBJ;ADyBE;EACE,WAAA;EACA,eAAA;ACvBJ;AD0BE;EAlGF;IAmGI,gBAAA;ECvBF;AACF;ADyBE;EACE,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ACvBJ;AD0BE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;ACxBJ;AD4BQ;EACE,aAAA;AC1BV;AD+BI;EACE,kBAAA;EACA,SAAA;EACA,aAAA;AC7BN;ADgCI;EACE,eAAA;AC9BN;ADkCM;EACE,aAAA;AChCR;ADoCI;EACE,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,2BAAA;EAEA,+CAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;ACnCN;ADsCM;EApBF;IAqBI,mBAAA;IACA,WAAA;IACA,gCAAA;IACA,WAAA;IACA,eAAA;ECnCN;AACF;ADqCM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;ACnCR;ADqCQ;EACE,mBAAA;ACnCV;ADuCQ;EApBF;IAqBI,aAAA;ECpCR;EDsCQ;IACE,0BAAA;IACA,eAAA;ECpCV;EDuCQ;IACE,aAAA;ECrCV;AACF;ADwCQ;EACE,6BAAA;ACtCV;ADwCU;EACE,6BAAA;EACA,uBAAA;ACtCZ;AD0CQ;EACE,+BAAA;EACA,yBAAA;ACxCV;AD2CQ;EACE,qBAAA;ACzCV;AD4CQ;EACE,oBAAA;EACA,qBAAA;AC1CV;ADiDE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8CAAA;EACA,gCAAA;EACA,8BAAA;AC/CJ;ADiDI;EAVF;IAWI,eAAA;IACA,8BAAA;EC9CJ;EDgDI;IACE,gBAAA;EC9CN;EDiDI;IACE,WAAA;IACA,uBAAA;IACA,mBAAA;EC/CN;AACF;ADkDI;EACE,WAAA;EACA,UAAA;AChDN;ADmDI;EACE,4BAAA;EACA,iBAAA;ACjDN;ADmDM;EACE,8BAAA;ACjDR;ADqDI;EACE,mBAAA;ACnDN;ADwDM;EACE,gBAAA;EACA,YAAA;ACtDR;ADyDM;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;ACvDR;AD2DI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;ACzDN;AD2DM;EALF;IAMI,eAAA;IACA,WAAA;ECxDN;AACF;AD2DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;ACzDN;AD4DI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AC3DN;AD8DM;EACE,wBAAA;EACA,SAAA;AC5DR;AD8DM;EACE,0BAAA;AC5DR;ADiEE;EACE,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AC/DJ;ADkEM;EACE,iBAAA;AChER;ADkEM;EACE,iBAAA;AChER;ADqEM;EACE,kBAAA;ACnER;ADqEM;EACE,kBAAA;ACnER;ADwEM;EACE,wBAAA;EACA,oBAAA;EACA,0CAAA;EACA,8BAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ACtER;AD4EQ;EACE,gCAAA;EACA,2BAAA;AC1EV;AD4EQ;EACE,mBAAA;EACA,2BAAA;AC1EV;AD6EQ;EACE,aAAA;AC3EV;ADqFU;EACE,2BAAA;ACnFZ;ADqFU;EACE,2BAAA;ACnFZ;ADuFQ;EACE,yBAAA;ACrFV;ADuFU;EACE,oBAAA;ACrFZ;ADyFQ;EACE,sBAAA;EACA,0BAAA;EACA,gCAAA;EACA,YAAA;EACA,8CAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;ACvFV;ADyFU;EACE,gCAAA;ACvFZ;ADyFU;EACE,iCAAA;ACvFZ;AD0FU;EACE,oBAAA;ACxFZ;AD0FY;EACE,cAAA;EACA,qBAAA;ACxFd;AD2FY;EACE,gBAAA;ACzFd;ADkGE;EACE,qBAAA;EACA,sBAAA;EACA,wCAAA;AChGJ;ADmGE;EACE,wCAAA;ACjGJ;ADoGE;EACE,+CAAA;AClGJ;;AA5XA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;AA+XF;;AAxXE;EACE,oBAAA;AA2XJ;AAzXI;;EAEE,kBAAA;AA2XN;AAxXI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AA0XN;AAvXI;EACE,gBAAA;AAyXN;AAtXI;EACE,qBAAA;AAwXN;AArXI;EACE,sBAAA;AAuXN;AArXM;EACE,gBAAA;AAuXR;AAnXI;EACE,kBAAA;EACA,oBAAA;AAqXN;AAlXI;EACE,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AAoXN;AAjXI;EACE,oBAAA;EACA,qBAAA;EACA,gBAAA;AAmXN;AAhXI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAkXN;AA/WI;EACE,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;AAiXN;AA3WE;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AA6WJ;AA3WI;EACE;IACE,WAAA;EA6WN;AACF;AAzWE;EACE,WAAA;AA2WJ;AAxWE;EAEI;IACE,WAAA;EAyWN;AACF;AApWE;EACI,mBAAA;EACA,oBAAA;EACA,6BAAA;AAsWN;AApWM;EACE,6BAAA;AAsWR;AAnWM;EACE,oCAAA;AAqWR;;AAhWA;EACE,kBAAA;EACA,eAAA;AAmWF;AAjWE;EAJF;IAKI,UAAA;IACA,oBAAA;EAoWF;EAlWE;IACE,WAAA;EAoWJ;AACF;AAjWE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,kDAAA;EACA,wBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;AAmWJ;AAjWI;EAZF;IAaI,qBAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;EAoWJ;AACF;AAlWI;EACE,aAAA;EACA,sBAAA;AAoWN;AAjWI;EACE,eAAA;AAmWN;AAjWM;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAmWR;AAjWQ;EACE,iBAAA;AAmWV;AAhWQ;EACE,yBAAA;EACA,sBAAA;EACA,+BAAA;AAkWV;AAhWU;EACE,qBAAA;AAkWZ;AA9VQ;EACE,yBAAA;EACA,sBAAA;EACA,+BAAA;AAgWV;;AAxVA;EACE,aAAA;AA2VF;AAzVE;EACE,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2VJ;AAzVI;EACE,qBAAA;AA2VN;AAxVI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AA0VN;AAtVE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAwVJ;AArVE;EACE,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AAuVJ","sourcesContent":[".dark {\n  .paylixecommerce-table table tbody tr td {\n    border-top: 1px solid var(--black1) !important;\n  }\n  .paylixecommerce-table table thead tr th {\n    background: var(--black1);\n  }\n\n  .paylixecommerce-table-pagination {\n    border-top: 1px solid var(--black1) !important;\n    background: var(--black1);\n  }\n\n  .page-size-container {\n    .select-container {\n      background-color: var(--white);\n    }\n  }\n}\n\n.paylixecommerce-table {\n  width: 100%;\n  overflow-x: auto;\n\n  &-clear {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 5rem;\n\n    &-icon {\n      margin-bottom: 1.5rem;\n      width: 3.5rem;\n      height: 3.5rem;\n      border-radius: 100%;\n      background: var(--purple0);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        width: 1.5rem;\n        height: 1.5rem;\n      }\n    }\n    &-title {\n      margin-bottom: .5rem;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 19px;\n      text-align: center;\n      color: var(--black9);\n    }\n    &-text {\n      margin-bottom: 1.5rem;\n      color: var(--black5);\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  &-container {\n    border-radius: .5rem;\n    box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n\n    &.cursor-pointer table tr td {\n      cursor: pointer;\n    }\n\n    .paylixecommerce-table {\n      background: var(--white);\n      border-radius: .5rem .5rem 0 0;\n    }\n\n    &.skip-pagination {\n      border-radius: .5rem;\n      box-shadow: none;\n\n      .paylixecommerce-table {\n        border-radius: .5rem;\n        box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n\n        table {\n          border-radius: .5rem;\n        }\n      }\n    }\n  }\n\n  tbody {\n\n    tr {\n      &:nth-last-child(-n+3) {\n        .paylixecommerce-table-actions-modal {\n          flex-direction: row;\n          top: -1rem;\n          right: 1.5rem;\n          width: auto;\n          transform: none;\n        }\n      }\n    }\n  }\n\n  table {\n    border-radius: 0.5rem;\n  }\n\n  &-container {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  @media (max-width: 768px) {\n    overflow: scroll;\n  }\n\n  &-nothing {\n    padding: 2rem 0;\n    color: var(--black9);\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  &-actions {\n    display: flex;\n    justify-content: flex-end;\n    position: relative;\n    padding: .25rem .5rem;\n\n    img {\n      &:hover {\n        & + div {\n          display: flex;\n        }\n      }\n    }\n\n    & > div {\n      position: absolute;\n      top: 1rem;\n      display: none;\n    }\n\n    & > img {\n      cursor: pointer;\n    }\n\n    &:hover {\n      .paylixecommerce-table-actions-modal {\n        display: flex;\n      }\n    }\n\n    &-modal {\n      z-index: 9;\n      position: absolute;\n      top: calc(100% - .5rem);\n      right: -5rem;\n      display: none;\n      flex-direction: column;\n      width: 8rem;\n      background: var(--white);\n      transform: translateX(-50%);\n\n      box-shadow: 0 4px 24px -4px rgba(0, 0, 0, 0.08);\n      border-radius: .5rem;\n      font-size: 14px;\n      margin-top: .5rem;\n      overflow: hidden;\n      background: var(--white);\n      border: none;\n\n\n      @media (max-width: 768px) {\n        flex-direction: row;\n        width: auto;\n        top: calc(50% - 25px) !important;\n        right: 2rem;\n        transform: none;\n      }\n\n      & > div, & > a, & > span {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        padding: 0 0.75rem;\n        height: 36px;\n        line-height: 36px;\n        color: var(--black5) !important;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        white-space: nowrap;\n\n        span {\n          margin-left: .5rem;\n        }\n\n\n        @media (max-width: 768px) {\n          padding: 1rem;\n\n          i {\n            margin-right: 0 !important;\n            font-size: 1rem;\n          }\n\n          & > span {\n            display: none;\n          }\n        }\n\n        &.delete-icon {\n          color: var(--red6) !important;\n\n          &:hover {\n            color: var(--red6) !important;\n            background: var(--red0);\n          }\n        }\n\n        &:hover {\n          color: var(--black9) !important;\n          background: var(--black1);\n        }\n\n        img {\n          margin-right: .75rem;\n        }\n\n        i {\n          color: var(--black9);\n          margin-right: .75rem;\n        }\n      }\n    }\n\n  }\n\n  &-pagination {\n    display: flex;\n    justify-content: space-between;\n    color: var(--black6);\n    padding: 1rem 1.25rem;\n    list-style: none;\n    border-top: 1px solid var(--black0) !important;\n    border-radius: 0 0 .5rem .5rem;\n    background-color: var(--white);\n\n    @media (max-width: 768px) {\n      flex-wrap: wrap;\n      flex-direction: column-reverse;\n\n      .page-size-container {\n        margin-bottom: 0;\n      }\n\n      & > div {\n        width: 100%;\n        justify-content: center;\n        margin-bottom: 1rem;\n      }\n    }\n\n    button {\n      width: 2rem;\n      padding: 0;\n    }\n\n    button.active {\n      border-color: var(--purple6);\n      border-width: 2px;\n\n      &:hover {\n        background-color: var(--white);\n      }\n    }\n\n    button.more svg {\n      margin-top: 0.25rem;\n    }\n\n    .page-size-container {\n\n      .select-container {\n        max-height: 2rem;\n        height: 2rem;\n      }\n\n      > span {\n        font-size: 13px;\n        font-weight: 500;\n        color: var(--black4);\n      }\n    }\n\n    & > div {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n        gap: .5rem;\n      }\n    }\n\n    .paylixecommerce-select {\n      width: 7rem;\n      height: 2rem;\n      margin-left: 1rem;\n      font-size: .8rem;\n    }\n\n    .paylixecommerce-input {\n      width: 5rem;\n      height: 2rem;\n      text-align: center;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n      background: var(--white);\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n\n\n      &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n      &[type=number]{\n        -moz-appearance: textfield;\n      }\n    }\n  }\n\n  table {\n    background: var(--white);\n    border-radius: .5rem .5rem .5rem .5rem;\n    margin-bottom: 0;\n    table-layout: auto;\n    width: 100%;\n\n    &.last-right {\n      thead tr th:last-child {\n        text-align: right;\n      }\n      tbody tr td:last-child {\n        text-align: right;\n      }\n    }\n\n    &.last-center {\n      thead tr th:last-child {\n        text-align: center;\n      }\n      tbody tr td:last-child {\n        text-align: center;\n      }\n    }\n\n    thead {\n      th {\n        background: var(--white);\n        color: var(--black4);\n        padding: 0.875rem .75rem 0.875rem 1.25rem;\n        border-bottom: none !important;\n        border-top: none !important;\n        cursor: pointer;\n        white-space: nowrap;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        line-height: 16px;\n\n        & > span {\n          //display: none;\n        }\n\n        &:first-child {\n          padding-left: 1.25rem !important;\n          border-radius: .5rem 0 0 0;\n        }\n        &:last-child {\n          padding-right: 1rem;\n          border-radius: 0 .5rem 0 0;\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n\n    tbody {\n\n      tr {\n\n        &:last-child {\n          td:first-child {\n            border-radius: 0 0 0 .5rem;\n          }\n          td:last-child {\n            border-radius: 0 0 .5rem 0;\n          }\n        }\n\n        &:hover {\n          background: var(--black0);\n\n          td {\n            color: var(--black9);\n          }\n        }\n\n        td {\n          vertical-align: middle;\n          padding: 13px 0 !important;\n          padding-left: 1.25rem !important;\n          border: none;\n          border-top: 1px solid var(--black0) !important;\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 13px;\n          line-height: 16px;\n          color: var(--black9);\n\n          &:first-child {\n            padding-left: 1.25rem !important;\n          }\n          &:last-child {\n            padding-right: 1.25rem !important;\n          }\n\n          a {\n            color: var(--black9);\n\n            &:hover {\n              color: #6461FC;\n              text-decoration: none;\n            }\n\n            b {\n              font-weight: 600;\n            }\n          }\n        }\n      }\n    }\n  };\n\n\n  &::-webkit-scrollbar {\n    width: 3px !important;\n    height: 3px !important;\n    background-color: transparent !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0,0,0,0.3) !important;\n  }\n\n}\n\n\n\n","@import \"../../../../../components/table2/index.scss\";\n\n\nspan.color-purple {\n  color: var(--purple6);\n  font-size: 12px;\n  line-height: 12px;\n}\n\n.product-screen {\n\n\n\n  div.mde-preview div.mde-preview-content {\n    color: var(--black9);\n\n    h1 + p:first-child, h2 + p:first-child, h3 + p:first-child, h4 + p:first-child, h5 + p:first-child, h6 + p:first-child,\n    h1 + ul:first-child, h2 + ul:first-child, h3 + ul:first-child, h4 + ul:first-child, h5 + ul:first-child, h6 + ul:first-child {\n      margin-top: .5rem;\n    }\n\n    h1, h2, h3, h4, h5, h6 {\n      margin-bottom: 0;\n      border-bottom: 0;\n      border-bottom: none;\n    }\n\n    h2, h3, h4, h5, h6 {\n      margin-top: 1rem;\n    }\n\n    a {\n      color: var(--purple6);\n    }\n\n    p {\n      margin-bottom: .25rem;\n\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n\n    p, ol, ul {\n      font-size: .85rem;\n      color: var(--black7);\n    }\n\n    blockquote {\n      padding: 0.75rem;\n      border-radius: 0.25rem;\n      margin-top: 1rem;\n      margin-left: 0;\n      border-left: 0.25em solid var(--black1);\n    }\n\n    ol, ul {\n      line-height: 1.25rem;\n      padding-left: 0.75rem;\n      list-style: disc;\n    }\n\n    h3 {\n      font-size: 1rem;\n      line-height: 1.5rem;\n      margin-top: 0.5rem;\n      margin-bottom: 0.5rem;\n    }\n\n    code {\n      color: #d63384;\n      padding: 0.25rem 0.5rem;\n      margin: 0 0.125rem;\n      font-size: 90%;\n      background-color: black;\n      border-radius: .5rem;\n    }\n\n  }\n\n\n  &-filters-block {\n    display: flex;\n    gap: .75rem;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n\n    @media (max-width: 500px) {\n      & > div {\n        width: 100%;\n      }\n    }\n  }\n\n  .paylixecommerce-table tbody tr:nth-last-child(-n+3) .paylixecommerce-table-actions-modal {\n    right: 2rem;\n  }\n\n  @media (max-width: 768px) {\n    .screen-filters {\n      .product-menu {\n        width: 100%;\n      }\n    }\n  }\n\n\n  .edit-modal::-webkit-scrollbar {\n      width: 0 !important;\n      height: 0 !important;\n      background-color: transparent;\n\n      &-track {\n        background-color: transparent;\n      }\n\n      &-thumb {\n        background-color: rgba(0, 0, 0, 0.2);\n      }\n  }\n}\n\n.product-menu {\n  position: relative;\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    width: 50%;\n    align-self: flex-end;\n\n    button {\n      width: 100%;\n    }\n  }\n\n  &-dropdown {\n    position: absolute;\n    min-width: 260px;\n    width: 260px;\n    background: var(--white);\n    border-radius: .5rem;\n    box-shadow: 0 4px 24px -4px rgba(18, 20, 23, 0.08);\n    top: calc(100% + .5rem);\n    display: none;\n    right: 0;\n    z-index: 9;\n\n    @media (max-width: 768px) {\n      border-radius: .5rem;\n      min-width: auto;\n      width: 100%;\n      max-width: 100%;\n    }\n\n    &.open {\n      display: flex;\n      flex-direction: column;\n    }\n\n    &-body {\n      padding: .5rem;\n\n      & > a, & > div {\n        padding: .5rem;\n        border-radius: .5rem;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 17px;\n        color: var(--black5);\n\n        span {\n          margin-left: 1rem;\n        }\n\n        &:hover {\n          background: var(--black1);\n          border-radius: .25rem;\n          color: var(--black9) !important;\n\n          svg * {\n            stroke: var(--black9);\n          }\n        }\n\n        &.active {\n          background: var(--black1);\n          border-radius: .25rem;\n          color: var(--black9) !important;\n        }\n      }\n    }\n\n  }\n}\n\n.product-table-type {\n  display: flex;\n\n  &-icon {\n    background: var(--black0);\n    width: 2.5rem;\n    min-width: 2.5rem;\n    height: 2.5rem;\n    border-radius: .5rem;\n    object-fit: cover;\n    margin-right: .75rem;\n    background: var(--black0);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg * {\n      stroke: var(--black3);\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      overflow: hidden;\n      border-radius: 0.5rem;\n    }\n  }\n\n  &-date {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: var(--black4);\n    margin-top: .25rem;\n  }\n\n  &-title {\n    display: flex;\n    justify-content: space-around;\n    flex-direction: column;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
